import React from "react";
import emailIcon from "../../../assets/icon-email.svg";

import "./styles.css";

export const IconEmail = () => {
  return <img className="icon-email" src={emailIcon} alt="email-icon" />;
};
